module.exports = __webpack_public_path__ + "media/images/great-match-f168ac0aeaf398391cbf8ab87e968f33.svg";